import { createRouter, createWebHistory } from 'vue-router'
import IdleView from '../views/IdleView.vue'
import IncomingCallView from '../views/IncomingCallView.vue'
import ConnectingView from '../views/ConnectingView.vue'
import ActiveCallView from '../views/ActiveCallView.vue'
import MissedCallView from '../views/MissedCallView.vue'
import AvailabilityConfirmView from '../views/AvailabilityConfirmView.vue'
import DeclineConfirmView from '../views/DeclineConfirmView.vue'
import BreakthroughCallView from '../views/BreakthroughCallView.vue'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes: [
    {
      path: '/',
      name: 'idle',
      component: IdleView,
    },
    {
      path: '/incoming/:sessionId',
      name: 'incoming',
      component: IncomingCallView,
      props: true,
    },
    {
      path: '/connecting/:sessionId',
      name: 'connecting',
      component: ConnectingView,
      props: true,
    },
    {
      path: '/call/:sessionId',
      name: 'call',
      component: ActiveCallView,
      props: true,
    },
    {
      // sessionId is optional – state comes from callStore
      path: '/missed/:sessionId?',
      name: 'missed',
      component: MissedCallView,
      props: true,
    },
    {
      path: '/availability-confirm',
      name: 'availability-confirm',
      component: AvailabilityConfirmView,
    },
    {
      path: '/decline-confirm',
      name: 'decline-confirm',
      component: DeclineConfirmView,
    },
    {
      path: '/breakthrough/:sessionId',
      name: 'breakthrough',
      component: BreakthroughCallView,
      props: true,
    },
  ],
})

export default router
